import React, { useMemo, useState } from "react";
import { AutoComplete, Select, Spin } from "antd";
import debounce from "lodash/debounce";
import { useSearchParams } from "react-router-dom";
import employerApi from "../../features/employer/api";
import { HTTP_RESPONSE_CODES, SEARCH_TYPE, USER_TYPE } from "../../constant";
import candidateApi from "../../features/candidate/api";
import { values } from "lodash";

const SearchDropDown = ({
  placeholder,
  debounceTimeout = 800,
  type,
  val,
  setVal
}) => {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false); 

  const [searchParams, setSearchParams] = useSearchParams();
  const isUserSearch = type === USER_TYPE.EMPLOYER || type === USER_TYPE.CANDIDATE;
  const searchValue = val?.toLowerCase() === "search" ? "" : val || "";
  const SearchComponent = isUserSearch ? AutoComplete : Select;

  const handleKeyPress = (value) => {
    if(value.key == "Enter"){
      value.preventDefault();
      value.stopPropagation();
      setVal(value.target.value);
      doSearch(value.target.value);
    }
  }

  const handleSelect = (value) => {
    setVal(value);
    doSearch(value);
    setOpen(false); 
  }

  const doSearch = (val) => {
    setOpen(false);
    if (!val || val === "undefined") {
      if(type === USER_TYPE.EMPLOYER || type === USER_TYPE.CANDIDATE) {      
        searchParams.delete("search");
      } else if (type === SEARCH_TYPE.CAMPAIGN) {
        searchParams.delete("Campaign");
      } else {
        searchParams.delete("PvtEmpIds");
      }
      setSearchParams(searchParams);
      return;
    }
    if (type === USER_TYPE.EMPLOYER || type === USER_TYPE.CANDIDATE) {
      searchParams.set("search", val);
    } else if (type === SEARCH_TYPE.CAMPAIGN) {
      searchParams.set("Campaign", val);
    } else {
      if(Number(val)){
        searchParams.set("PvtEmpIds", "[" + val + "]");
      }
    }
    searchParams.set("page", 1);
    searchParams.set("limit", 10);
    setSearchParams(searchParams);
  }

  const debounceFetcher = useMemo( () => {
    const loadOptions = async (value) => {
      setOptions([]);
      setFetching(true);
      if (value) {
        setOpen(true); 
      } else {
        setOpen(false); 
      }

      if(type === USER_TYPE.EMPLOYER || type === USER_TYPE.CANDIDATE) {        
        let response = "";
        if(type === USER_TYPE.EMPLOYER) {
          response = await employerApi.suggestionEmployer(value);
        } 
        if(type === USER_TYPE.CANDIDATE) {
          response = await candidateApi.suggestionCandidate(value);
        }
        if (response.status == HTTP_RESPONSE_CODES.SUCCESS) {
          let newOptions = response.data.map((data) => ({
            label: `${data.Profiles.FirstName} ${data.Profiles.LastName}`,
            value: `${data.Profiles.FirstName} ${data.Profiles.LastName}`,
            key: `${data._id}`,
          }));
          setOptions(newOptions);
          setFetching(false);
        }
      }

      if(type === SEARCH_TYPE.CAMPAIGN) {
        let queryString = "";
        if(searchParams.get("StartDate") && searchParams.get("EndDate")) {
          queryString = `&StartDate=${searchParams.get("StartDate")}&EndDate=${searchParams.get("EndDate")}`;
        }
        const response = await candidateApi.suggestionCandidateCampaign("?name=" + value + queryString);
        if (response?.status == HTTP_RESPONSE_CODES.SUCCESS) {
          let newOptions = response.data.map((data) => ({
            label: `${data._id}`,
            value: `${data._id}`,
            key: `${data._id}`,
          }));
          setOptions(newOptions);
          setFetching(false);
        }
      }

      if(type === SEARCH_TYPE.CANDIDATE_TYPE && value) {
        const response = await candidateApi.typeCandidate("?name=" + value);
        if (response.status == HTTP_RESPONSE_CODES.SUCCESS) {
          let newOptions = response.data.map((data) => ({
            label: `${data.PvtEmpName}`,
            value: `${data.AccountId}`,
            key: `${data._id}`,
          }))
          setOptions(newOptions);
          setFetching(false);
        }
      }

    };
    return debounce(loadOptions, debounceTimeout);
  }, [debounceTimeout]);

  const handleSearch = (value) => {
    if (isUserSearch) {
      setVal(value);
    }
    debounceFetcher(value);
  }
  

  return (
    <SearchComponent
      labelInValue={false}
      showSearch
      filterOption={false}
      optionFilterProp="label"
      placeholder={placeholder}      
      onInputKeyDown={handleKeyPress}
      onSelect={handleSelect}
      value={isUserSearch ? searchValue : val}
      onChange={isUserSearch ? setVal : undefined}
      open={open}
      onSearch={handleSearch}
      onBlur={() => setOpen(false)}
      notFoundContent={fetching ? <Spin size="small" /> : null}      
      options={options}
      style={{
        width: type === "candidateType" ? 130 : 250,
      }}
    />
  );
};

export default SearchDropDown;
